import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SiteView } from "@/components/site/SiteView";

export const SiteLoading = ({ error }) => (
  <div className="min-h-screen bg-[#08080A] flex flex-col items-center justify-center gap-8 px-6 text-center" data-testid="site-loading">
    <img src="/logo.png" alt="Gran Hotel Sé" className="h-14 w-auto opacity-80" />
    {error ? <p className="text-sm text-[#A1A1AA]">{error}</p> : <div className="h-px w-24 bg-[#C5A059]/60 animate-pulse" />}
  </div>
);

export default function PublicSite() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => setError("Não foi possível carregar o site. Tente novamente em instantes."));
  }, []);

  if (!content) return <SiteLoading error={error} />;
  return <SiteView content={content} />;
}
